<template>
    <div>
        <div class="search-box">
            <p>年份：</p>
            <a-select class="input-box" v-model="searchFrom.year" allowClear>
                <a-select-option v-for="y in yearOptions" :key="y" :value="y">{{ y }}年</a-select-option>
            </a-select>
            <p>部门：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.orgCode">
                <a-select-option v-for="(item, index) in xyArr" :key="index" :value="item.dataCode">{{ item.dataName }}</a-select-option>
            </a-select>
            <p>教师姓名/编号：</p>
            <a-input class="input-box" v-model="searchFrom.teacherIdOrName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button
                type="primary"
                icon="eye"
                class="btn"
                @click="selectedRowKeys[0] == null ? notifySelect() : goView()"
                v-if="permissions.indexOf('faculty:yearBonus:queryAll') > -1">
                查看详情
            </a-button>
            <a-button
                type="primary"
                icon="export"
                class="btn"
                @click="doExport()"
                v-if="permissions.indexOf('faculty:yearBonus:export') > -1">
                导出
            </a-button>
        </div>
        <a-table
            rowKey="id"
            :customRow="onClickRow"
            :columns="columns"
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '600px' }"
            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list, exportFile } from '@/baseAPI/yearBonus'

    const formatMoney = (v) => v != null ? Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'

    const columns = [
        { title: '序号', align: 'center', width: 60, customRender: (text, row, index) => index + 1 + '' },
        { title: '年份', dataIndex: 'year', align: 'center', width: 80 },
        { title: '工号', dataIndex: 'teacherId', align: 'center', width: 110 },
        { title: '姓名', dataIndex: 'teacherName', align: 'left', width: 90 },
        { title: '部门', dataIndex: 'orgName', align: 'left', width: 120 },
        { title: '职称', dataIndex: 'technicalTitleName', align: 'left', width: 90 },
        { title: '人员类别', dataIndex: 'personnelCategory', align: 'center', width: 110 },
        { title: '在岗月份', dataIndex: 'onJobMonths', align: 'center', width: 80 },
        { title: '工作量完成', dataIndex: 'workloadCompletion', align: 'center', width: 90,
            customRender: (text) => {
                return text || '-'
            }
        },
        { title: '基础奖励', dataIndex: 'baseReward', align: 'right', width: 100, customRender: formatMoney },
        { title: '完成工作量奖励', dataIndex: 'completionReward', align: 'right', width: 120, customRender: formatMoney },
        { title: '基本奖励', dataIndex: 'basicReward', align: 'right', width: 100, customRender: formatMoney },
        { title: '工作量奖励', dataIndex: 'workloadReward', align: 'right', width: 100, customRender: formatMoney },
        { title: '绩效专项奖励', dataIndex: 'performanceReward', align: 'right', width: 110, customRender: formatMoney },
        { title: '年终奖合计', dataIndex: 'totalBonus', align: 'right', width: 110, customRender: formatMoney },
    ]

    export default {
        name: 'yearBonus',
        data() {
            return {
                xyArr: [],
                data: [],
                loading: false,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    pageSizeOptions: ['10', '20', '50'],
                    showTotal: (total) => '共' + total + '条',
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0,
                },
                selectedRowKeys: [],
                searchFrom: { year: null, orgCode: '', teacherIdOrName: '' },
                permissions: ['faculty:yearBonus:add', 'faculty:yearBonus:edit', 'faculty:yearBonus:delete', 'faculty:yearBonus:queryAll', 'faculty:yearBonus:export'],
                columns,
                yearOptions: [],
            }
        },
        mounted() {
            // 生成年份选项（近5年）
            const cur = new Date().getFullYear()
            for (let i = 0; i < 5; i++) this.yearOptions.push(cur - i)
            this.searchFrom.year = new Date().getMonth() >= 9 ? cur : cur - 1

            getDicts({ dataCode: 'XY', status: true }).then(res => {
                this.xyArr = res.data.dicts
            }).catch(() => {})

            this.permissions = this.$store.state.user.permissions == null ? [] : this.$store.state.user.permissions
            // 补充mock权限方便预览
            if (this.permissions.length === 0) {
                this.permissions = ['faculty:yearBonus:add', 'faculty:yearBonus:edit', 'faculty:yearBonus:delete', 'faculty:yearBonus:queryAll', 'faculty:yearBonus:export']
            }
            this.fetch()
        },
        watch: {
            '$route': {
                handler(newVal) {
                    if (newVal.path === '/admin/faculty/yearBonus') this.fetch()
                },
                deep: true,
                immediate: true,
            }
        },
        methods: {
            fetch() {
                this.loading = true
                const params = {
                    current: this.pagination.current,
                    size: this.pagination.pageSize,
                    year: this.searchFrom.year,
                    orgCode: this.searchFrom.orgCode,
                    teacherIdOrName: this.searchFrom.teacherIdOrName,
                }
                list(params).then(res => {
                    this.data = res.data.records || []
                    this.pagination.total = res.data.total || 0
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            searchList() {
                this.selectedRowKeys = []
                this.pagination.current = 1
                this.fetch()
            },
            handleTableChange(pagination) {
                this.selectedRowKeys = []
                const pager = { ...this.pagination }
                pager.current = pagination.current
                pager.pageSize = pagination.pageSize
                this.pagination = pager
                this.fetch()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys
            },
            onClickRow(record) {
                return {
                    on: {
                        click: () => {
                            const keys = [...this.selectedRowKeys]
                            const index = keys.indexOf(record.id)
                            if (index >= 0) {
                                keys.splice(index, 1)
                            } else {
                                keys.push(record.id)
                            }
                            this.onSelectChange(keys)
                        }
                    }
                }
            },
            notifySelect() {
                this.$notification['info']({ message: '提示', description: '请选择一条记录' })
            },
            goView() {
                if (this.selectedRowKeys.length !== 1) {
                    this.$notification['info']({ message: '提示', description: '请选择一条记录' })
                    return
                }
                const info = this.data.find(e => e.id === this.selectedRowKeys[0])
                this.$router.push({ path: '/admin/faculty/yearBonus/info', query: { type: 'view', id: info.id } })
            },
            doExport() {
                const params = {
                    year: this.searchFrom.year,
                    orgCode: this.searchFrom.orgCode,
                    teacherIdOrName: this.searchFrom.teacherIdOrName,
                }
                exportFile(params).then(res => {
                    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `年终奖_${new Date().getTime()}.xlsx`
                    link.click()
                    window.URL.revokeObjectURL(url)
                    this.$notification['success']({ message: '成功', description: '导出成功' })
                }).catch(() => {
                    this.$notification['error']({ message: '错误', description: '导出失败' })
                })
            },
        }
    }
</script>

<style scoped>
.search-box {
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.60);
    margin-bottom: 10px;
}
.search-box p { display: inline-block; }
.search-box .input-box { margin-right: 1rem; width: 10rem; }
.operation-box { display: flex; margin-bottom: 10px; }
.operation-box .btn { margin-right: 1rem; }
.ant-table-wrapper >>> .ant-table-thead > tr > th,
.ant-table-wrapper >>> .ant-table-tbody > tr > td { padding: 10px 14px; }
</style>
